module.exports = __webpack_public_path__ + "img/cs-tab-icon6.b1def4ef.png";